import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { useFormHook } from '@Hooks/index.ts';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useBoundStore } from '@Store/useBoundStore';
import { RoutesMap } from '@Router/router.types';
import { EddEmbeddedFields } from '../fields.types';
export const useMonthlyPaymentVolumeLogic = () => {
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation();

  const formMethods = useFormHook({
    schemaTitle: 'MonthlyPaymentVolume',
    formDefaultValues: {
      [EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS) ||
        '',
      [EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME) || '',
    },
    formSchema: z.object({
      [EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS]: z.string().min(1),
      [EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME]: z.string().min(1),
    }),
  });

  const handleSubmit = async () => {
    /** Save to local store */
    saveEddQuestionToLocalStore({
      question: t('monthlyPaymentVolume.groupATitle'),
      questionId: EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS,
      answer: formMethods.getValues(EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS),
    });
    saveEddQuestionToLocalStore({
      question: t('monthlyPaymentVolume.groupBTitle'),
      questionId: EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME,
      answer: formMethods.getValues(EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME),
    });

    /** Save to Server */
    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME);
    } catch (error) {
      /** TODO: Handle error - Check with PM */
      console.error(error);
    }
  };

  const monthlyTransactionsOptions = [
    {
      value: 'Under 50',
      label: 'Under 50',
    },
    {
      value: '50 to 100',
      label: '50 to 100',
    },
    {
      value: '101 to 250',
      label: '101 to 250',
    },
    {
      value: '251 or more',
      label: '251 or more',
    },
  ];

  const monthlyVolumeOptions = [
    {
      value: 'Under $10,000',
      label: 'Under $10,000',
    },
    {
      value: '$10,001 to $50,000',
      label: '$10,001 to $50,000',
    },
    {
      value: '$50,001 to $100,000',
      label: '$50,001 to $100,000',
    },
    {
      value: '$100,001 to $500,000',
      label: '$100,001 to $500,000',
    },
    {
      value: '$500,001 to $1,000,000',
      label: '$500,001 to $1,000,000',
    },
  ];

  return {
    formMethods,
    monthlyTransactionsOptions,
    monthlyVolumeOptions,
    handleSubmit,
    isPostingEddData,
  };
};
